import React, {useEffect, useState} from 'react';
import Wrapper from "../component/Wrapper";
import {homeD, install, menu, lang} from "../helpers/translate";
import Contact from "../component/Contact";
import Api from "../Api";
import Utils from "../helpers/Utils";
import Product from "../component/Product";
import postman from '../assets/img/icon/PostmanIcon.svg'
import _ from 'lodash'
import dev from '../assets/img/icon/dev.svg'
import swagger from '../assets/img/icon/SwaggerIcon.svg'
import Loader from "../component/Loader";
import {useNavigate, useParams} from "react-router";
import HelmetHeader from "../component/HelmetHeader";

function Developers(props) {
    const [api, setApi] = useState([])
    const [params, setParams] = useState([])
    const [loader, setLoader] = useState(true)
    const param = useParams()
    const navigate = useNavigate()
    useEffect(() => {
        (async () => {
            try {
                const {data} = await Api.getApi(lang[param?.lang || 'en'] || 1)
                setApi(data.api)
                let arr = data.api.map(s => Utils.sortParams(s.api_doc_translate))
                setParams(arr)
                setLoader(false)
            } catch (e) {
                console.log(e)
            }

        })()
    }, [param,lang])

    const handleClick = (event) => {
        const href = event.currentTarget.getAttribute('href');
        if (href === "https://ats.am/ATS-API.postman_collection.json") {
            event.preventDefault();
            fetch(href)
                .then(response => response.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'ATS-API.postman_collection.json';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                })
                .catch(error => console.error('Download failed:', error));
        }
    };
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (param.lang === 'ru') {
            navigate('/ru/apidocumentacia')
        }else if(param.lang){
            navigate(`/${param.lang}/api_document`)
        }
    }, [param.lang]);
  if(loader){
      return (
         <Loader/>
      );
  }else{
      return (
          <Wrapper>
              <HelmetHeader type="api"/>
              <div className="main_container">
                  <h1 className="d-flex align-items-center justify-content-between">
                      {homeD.api_title[lang[param?.lang || 'en'] || 1]}
                      <a href="https://ats.am/api-docs" target="_blank"> <img style={{width: 30, height: 30}} src={dev} alt="Go to API document"/></a>
                  </h1>
                  <hr/>
              </div>
              <div className="developer main_container">

                  <div className="api_part">
                      {windowWidth <= 768 ? <div className="connect dev">
                              <p>
                                  {install.swagger[lang[param?.lang || 'en'] || 1]}
                              </p>
                              <a style={{marginBottom:15}} href="https://ats.am/api-docs">
                                  <img style={{marginRight:5}} src={swagger} alt="Go to API document"/>
                                  {install.swaggerL[lang[param?.lang || 'en'] || 1]}

                              </a>
                              <p>
                                  {install.postman[lang[param?.lang || 'en'] || 1]}
                              </p>
                              <a href="https://ats.am/ATS-API.postman_collection.json" onClick={handleClick}>
                                  <img style={{marginRight:5}} src={postman} alt="Go to API document"/>
                                  {install.postmanL[lang[param?.lang || 'en'] || 1]}

                              </a>
                          </div>
                          : null}
                      <p>
                          {homeD.api_desc1[lang[param?.lang || 'en'] || 1]}

                      </p>
                      <p>
                          {homeD.api_desc[lang[param?.lang || 'en'] || 1]}

                      </p>
                      <p>
                          {homeD.api_desc2[lang[param?.lang || 'en'] || 1]}

                      </p>
                      <div className='api_block'>
                          {api.map((a, i) => (
                              <div key={_.uniqueId()}>
                                  <div className="api_header">
                                    <span>
                                    {a.type}
                                </span>
                                      <h3>
                                          {a.api_title_translate[0].title}
                                      </h3>
                                  </div>
                                  <p className="api_block_p">{a.api_title_translate[0].desc}</p>

                                  <p className="api_block_p">{homeD.example[lang[params?.lang || 'en'] || 1]}: {a.link}?key=185f8db32271fe25f561a</p>

                                  <p className="request_type">
                                      {params[i][0].length ? 'Body' : ''}
                                  </p>
                                  {params[i][0].length ? params[i][0].map(p => (
                                      <div key={_.uniqueId()}>
                                          <p><b>{p.param}</b> : <b>{p.dataType}</b></p>
                                          <p className="api_block_p">{p.desc}</p>

                                      </div>
                                  )) : null}
                                  <p className="request_type">
                                      {params[i][1].length ? 'Query' : ''}
                                  </p>
                                  {params[i][1].length ? params[i][1].map(p => (
                                      <div key={_.uniqueId()}>
                                          <p><b>{p.param}</b> : <b>{p.dataType}</b></p>
                                          <p className="api_block_p">{p.desc}</p>

                                      </div>
                                  )) : null}


                                  <div>
                                      <b>Response</b>
                                      <pre className="autorization">
                                        {a.id !== 4?a?.res:homeD.download_m[lang[param?.lang || 'en'] || 1]}
                                    </pre>
                                  </div>
                              </div>
                          ))}
                      </div>
                  </div>
                  {windowWidth > 435 ? <div>
                      {windowWidth > 768 ?
                          <div className="connect">
                              <p>
                                  {install.swagger[lang[param?.lang || 'en'] || 1]}
                              </p>
                              <a style={{marginBottom:15}}  href="https://ats.am/api-docs" target="_blank">
                                  <img src={swagger} style={{marginRight:5}} alt="Go to API document"/>
                                  {install.swaggerL[lang[param?.lang || 'en'] || 1]}

                              </a>
                              <p>
                                  {install.postman[lang[param?.lang || 'en'] || 1]}
                              </p>
                              <a href="https://ats.am/ATS-API.postman_collection.json" onClick={handleClick}>
                                  <img src={postman} style={{marginRight:5}} alt="Go to API document"/>
                                  {install.postmanL[localStorage.getItem('atsLang') || 1]}

                              </a>
                          </div> : null}
                      {windowWidth > 1024 ? <>
                          <div className="about_block">
                              <Product type="dev"/>
                          </div>
                          <Contact/>
                      </> : <>
                          <Contact/>
                          <div className="about_block">
                              <Product type="dev"/>
                          </div>
                      </>}
                  </div> : null}
              </div>
          </Wrapper>
      );
  }
}

export default Developers;
